import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData, Button } from 'types'
import { useGetConfigurationsQuery } from '@apis/mediacore/configuration'
import { ElementHTML } from '@helpers/helper.rendering'

interface ExternalProps {
  data: any
  from: string
  title: string
  paragraph: string
  underlineMode: boolean
  basicButton?: boolean
  form: any
  button: Button
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Form_6 = ({
  titles,
  data,
  from,
  title,
  paragraph,
  underlineMode,
  basicButton,
  form,
  button,
  titleElement,
  global_data,
  customBorderRadius
}: CombinedProps) => {
  const branch_office = global_data.branches
  const social = global_data?.pageConfig.social
  const icons = global_data?.pageConfig.design.icons || 'Solid'
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''
  const contact_data = global_data.contact_data

  const { data: modules } = useGetConfigurationsQuery(process.env.GATSBY_CLIENTID)

  const INVESTOR_CONFIGURATION = modules?.find(
    (config: { module: string }) => config.module === 'INVESTOR',
  )
  const OWNER_CONFIGURATION = modules?.find(
    (config: { module: string }) => config.module === 'OWNER',
  )

  const FormComponent = require(`@components/form/1`)?.default

  return (
    <section className="form-6 position-relative">
      <Container fluid>
        <Row className="contacto-main p-y-config">
          <Col
            lg={6}
            className="intro mx-auto pe-lg-5"
          >
            <ElementHTML
              children={title || 'Contacto'}
              elementType={titleElement || 'h4'}
              className={
                'mb-4 text-lg-start ' +
                (basicButton ? 'text-primary' : ' text-secondary text-center')
              }
            />
            <p className={'mb-5 text-lg-start ' + (basicButton ? '' : 'text-center')}>
              {paragraph
                ? paragraph
                : `Con gusto responderemos todas tus dudas y te guiaremos durante el proceso.`}
            </p>
            <FormComponent
              data={data}
              underlineMode={underlineMode}
              from={from}
              button={button}
              global_data={global_data}
              captcha={form?.captcha}
              italic={true}
              customBorderRadius={customBorderRadius}
            />
            <div id="alert-message"></div>
          </Col>
          <Col
            lg={{ span: 4, offset: 2 }}
            className={'data-column d-lg-block ' + (basicButton ? 'd-none' : '')}
          >
            <Col
              xs={{ span: 12, order: 1 }}
              lg={{ order: 1 }}
              // className="mb-lg-0 mb-0 position-fixed"
              className={'mb-lg-0 mb-0 ' + (basicButton ? 'position-fixed' : '')}
            >
              <div className="max-height-scroll">
                {titles?.global && (
                  <div className="item-contact mb-5">
                    <h5>{titles?.global}</h5>
                    {contact_data?.email! && (
                      <a
                        className="hover-service-link mb-lg-1 "
                        target="_blank"
                        href={'mailto:' + contact_data?.email}
                      >
                        {contact_data.email}
                      </a>
                    )}
                    {contact_data.phoneLine?.map((phone, index) => (
                      <p
                        key={index}
                        className={'mb-0 mb-lg-1 ' + (phone === '' ? 'd-none' : '')}
                      >
                        Teléfono {phone}
                      </p>
                    ))}
                    {global_data.college ? (
                      <p className="mb-0 mb-lg-1 ">
                        {global_data.college + ' ' + global_data.registration_number}
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                )}
                <div
                  className={
                    'office-wrapper text-center text-lg-start ' + (!basicButton ? 'mb-5' : '')
                  }
                >
                  {branch_office?.length > 0 &&
                    branch_office.map((office, index) => (
                      <div
                        className="mb-lg-5 mb-3"
                        key={index}
                      >
                        <ElementHTML
                          className={
                            'text-uppercase mb-4 ' +
                            (basicButton ? 'text-primary' : 'text-secondary')
                          }
                          children={
                            titles?.branch_office && office.name
                              ? `${titles?.branch_office} ${office.name}`
                              : titles?.branch_office || 'Oficina'
                          }
                          elementType={basicButton ? 'h5' : 'h4'}
                        />

                        <p>{office?.address} </p>
                        <p className="mt-3 mt-lg-0">
                          {office?.zip_code ? `(${office?.zip_code}) ` : ''}
                          {office?.city ? `${office?.city} ` : ''}
                          {office?.country ? office?.country : ''}
                        </p>
                        {office?.contact_data?.phonesLine?.map((tel, index) => (
                          <p
                            className="mt-3 mt-lg-0"
                            key={index}
                          >
                            Tel: {tel}
                          </p>
                        ))}
                        {office?.contact_data?.phonesMobile?.map((whatsapp, index) => (
                          <p
                            className="mt-3 mt-lg-0"
                            key={index}
                          >
                            Cel: 
                            <a
                              className={'hover-footer-link'}
                              target="_blank"
                              href={
                                'https://api.whatsapp.com/send?' +
                                'phone=' +
                                whatsapp.replaceAll('-', '')
                              }
                            >
                              {whatsapp.replace('5411', '(54-11) ')}
                            </a>
                          </p>
                        ))}
                        <p className={office?.college === '' ? 'd-none' : ''}>
                          Matrícula {office?.college}
                        </p>
                        <p className={office?.opening_hours === '' ? 'd-none' : ''}>
                          {office?.opening_hours}
                        </p>
                        {office?.contact_data?.emails?.map((email, index) => (
                          <p
                            key={index}
                            className="mt-3 mt-lg-0"
                          >
                            <a
                              key={index}
                              target="_blank"
                              className={'hover-footer-link secondary-hover '}
                              href={'mailto:' + email}
                            >
                              {email}
                            </a>
                          </p>
                        ))}
                      </div>
                    ))}
                  {/* {college && (
                    <p>
                      <a className="d-block">{college}</a>
                    </p>
                  )} */}
                </div>
                {titles?.social && (
                  <div className="item-contact social">
                    <h5>{titles?.social}</h5>
                    {social?.instagram && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social instagram"
                        href={social?.instagram}
                        className={social?.instagram ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-instagram${iconsStyle}`}></i>
                      </a>
                    )}
                    {social?.facebook && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social facebook"
                        href={social?.facebook}
                        className={social?.facebook ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-facebook${iconsStyle}`}></i>
                      </a>
                    )}
                    {social?.linkedin && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social linkedin"
                        href={social?.linkedin}
                        className={social?.linkedin ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-linkedin${iconsStyle}`}></i>
                      </a>
                    )}
                    {social?.youtube && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social youtube"
                        href={social?.youtube}
                        className={social?.youtube ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-youtube${iconsStyle}`}></i>
                      </a>
                    )}
                    {social?.twitter && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social twitter"
                        href={social?.twitter}
                        className={social?.twitter ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-twitter${iconsStyle}`}></i>
                      </a>
                    )}
                    {social?.tiktok && (
                      <a
                        target="_blank"
                        aria-label="Lea mas en la red social tiktok"
                        href={social?.tiktok}
                        className={social?.tiktok ? 'd-inline' : 'd-none'}
                      >
                        <i className={`icon-tiktok${iconsStyle}`}></i>
                      </a>
                    )}
                  </div>
                )}
              </div>
              <div className="investor-wrapper mt-3 mt-lg-5 mb-0">
                <div
                  className={
                    'item-contact row mb-0 button-separator ' +
                    (INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module
                      ? 'd-block'
                      : ' d-none')
                  }
                >
                  <ElementHTML
                    className={
                      'mb-4 text-center text-lg-start ' +
                      (basicButton ? 'text-primary' : 'text-secondary')
                    }
                    children={titles?.modules || 'Modulos'}
                    elementType={basicButton ? 'h5' : 'h4'}
                  />
                  {INVESTOR_CONFIGURATION?.module && (
                    <div className="d-block pb-2">
                      <a
                        className={
                          'btn mb-2 d-flex justify-content-between ' +
                          (basicButton ? 'btn-primary text-white w-100 ' : 'btn-investor')
                        }
                        target={'_blank'}
                        href={INVESTOR_CONFIGURATION.url_login}
                      >
                        <span>{INVESTOR_CONFIGURATION.text_cta || 'Inversores'}</span>
                        {!basicButton && <i className={'icon-investment' + iconsStyle}></i>}
                      </a>
                    </div>
                  )}
                  {OWNER_CONFIGURATION?.module && (
                    <div className="d-block">
                      <a
                        className={
                          'btn mb-2 d-flex justify-content-between ' +
                          (basicButton ? 'btn-primary text-white w-100 ' : 'btn-investor')
                        }
                        target={'_blank'}
                        href={OWNER_CONFIGURATION.url_login}
                      >
                        <span>{OWNER_CONFIGURATION.text_cta || 'Propietarios'}</span>
                        {!basicButton && <i className={'icon-investor-access' + iconsStyle}></i>}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Form_6
